<template>
    <div>
        <img :src="photo.path"/>

        <!-- I can't access a variable (title, firstName, lastName) that is not there yet
        (wait for async/await function to run), so do (v-if="photo.user") if I don't the code below works but
        there will be an error on the console-->
        <div v-if="photo.user" class="photoInfo">
            <p class="photoTitle">{{photo.title}}</p>
            <p class="photoName">{{photo.user.firstName}} {{photo.user.lastName}}</p>
        </div>
        <p class="photoDate">{{formatDate(photo.created)}}</p>
        <p class="description"> Description: {{photo.description}}</p>
        <p v-if="error">{{error}}</p>


        <div v-if="user" class="comment-from">
            <legend>Add a Comment</legend>
            <br>
            <input v-model="comment.name" placeholder="Your Name">
            <br>
            <br>
            <textarea v-model="comment.comment" placehold="comment"></textarea>
            <br>
            <button v-on:click="addComment">Upload</button>
        </div>

        <br>
        <p>Comments:</p>
        <div class="comment" v-for="comment in comments" v-bind:key="comment._id">
            <div><strong>Name: </strong>{{comment.name}}</div>
            <div><strong> Comment: </strong>{{comment.comment}}</div>
            <div><strong> Date: </strong> {{formatDate(comment.created)}}</div>
            <br>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    export default {
        name: 'Photo',
        data() {
            return {
                photo: {},
                error: '',
                comment: {
                    comment: '',
                    name: ''
                },
                comments: []
            }
        },
        created() {
            this.getPhoto();
        },
        methods: {
            //this.$route.params.id will get the id that is passed in from the :id in the route

            async getPhoto() {
                try {
                    let response = await axios.get('/api/photos/' + this.$route.params.id);
                    this.photo = response.data.photo;

                    response = await axios.get('/api/comments/' + this.$route.params.id);
                    this.comments = response.data;
                }catch (error) {
                    this.error = error.response.data.message;
                }
            },
            formatDate(date) {
                if (moment(date).diff(Date.now(), 'days') < 15)
                    return moment(date).fromNow();
                else
                    return moment(date).format('d MMMM YYYY');
            },
            async addComment() {
                try {
                    const comment = this.comment;
                    const newComment = await axios.post("/api/comments/" + this.photo._id, comment);
                    this.comments.push(newComment.data.comment);

                    this.comment.comment = '';
                    this.comment.name = '';

                } catch (error) {
                    this.error = "Error: " + error.response.data.message;
                }
            }

        },
        computed: {
            user() {
                return this.$root.$data.user;
            }
        }

    }
</script>

<style scoped>
    img {
        width: 100%;
    }

    .photoInfo {
        display: flex;
        justify-content: space-between;
        font-size: 0.8em;
    }

    .photoInfo p {
        margin: 0px;
    }

    .photoDate {
        font-size: 0.7em;
        font-weight: normal;
    }

    .description {
        font-size: 13px;
    }

    .comment-from {
        display: block;
        border-style: solid;
        padding: 15px;
    }
</style>